import { render, staticRenderFns } from "./defaultEdgeworkLinkEditor.vue?vue&type=template&id=8688a096&"
import script from "./defaultEdgeworkLinkEditor.vue?vue&type=script&lang=js&"
export * from "./defaultEdgeworkLinkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports